import React from 'react'

import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Box } from '@domain-group/suit-theme'

import Subtitle from './Subtitle'
import Title from './Title'

interface HeaderProps {
  callbacks: {
    goBack: VoidFunction,
  },
  children: React.ReactNode,
  imageComponent: React.ReactNode,
}

const Header = (props: HeaderProps) => {
  const {
    callbacks: {
      goBack,
    },
    children,
    imageComponent,
  } = props

  return (
    <Box
      borderBottom="1px solid"
      borderColor="lineColor"
      height={80}
      justifyContent="flex-start"
      padding="large"
    >
      <Box
        alignItems="center"
        as="a"
        borderRight="1px solid"
        borderColor="lineColor"
        color="bodyFontLightColor"
        fontSize="small"
        justifyContent="center"
        onClick={goBack}
        paddingRight="large"
        style={{ cursor: 'pointer' }}
        width="auto"
      >
        <FontAwesomeIcon icon={faAngleLeft} />
      </Box>

      <Box>
        {imageComponent && (
          <Box marginLeft="large" width="auto">
            {imageComponent}
          </Box>
        )}

        <Box flexDirection="column" justifyContent="center" marginLeft="large">
          {children}
        </Box>
      </Box>

    </Box>
  )
}

Header.Subtitle = Subtitle
Header.Title = Title

export default Header
